export enum RewardConfigurationType {
	PostPurchase = "PostPurchase",
	Open = "Open"
}
